<!-- Main-error-wrapper -->
<div class="main-error-wrapper page page-h">
    <img src="../../../assets/img/media/logout3.png" class="error-page" alt="error">
    <h2>You are logged out successfully</h2>
    <h6 (click)="navigateToLogin()" style="cursor: pointer;">Click here to login again</h6>
</div>
<!-- /Main-error-wrapper -->